/* globals lp, rxSwitchboard */
;(function(){
  var juiEvents = rxSwitchboard.subjects.jui_events;

  var beforeBreakpointChangedEvs = juiEvents
    .filter(function(ev){
      return ev.type === 'beforeBreakpointChanged';
    });

  var layoutChangeEvs = juiEvents
    .filter(function(ev){
      return ev.type === 'layoutChanged';
    });

  var breakpointChangeTimingEvs = beforeBreakpointChangedEvs
    .timestamp()
    .map(function(ev){
      return {
        fromBreakpoint: window.editor.page.getCurrentBreakpoint().name,
        toBreakpoint: ev.value.data,
        timestamp: ev.timestamp
      };
    })
    .filter(function(ev){
      return ev.fromBreakpoint !== ev.toBreakpoint;
    })
    .flatMap(function(startEv){

      var fromBreakpoint = startEv.fromBreakpoint
        , toBreakpoint   = startEv.toBreakpoint;

      return layoutChangeEvs
        .take(1)
        .timestamp()
        .map(function(endEv) {
          return {
            duration: endEv.timestamp - startEv.timestamp,
            fromBreakpoint: fromBreakpoint,
            toBreakpoint: toBreakpoint
          };
        });
    });

    lp.PerfSampling.registerSampleSource('breakpointChanged', breakpointChangeTimingEvs);

})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/performance/perf_breakpoint_changed.js
// module id = 1070
// module chunks = 0